import {BoundingBoxData} from '../hooks/useBoxData';

/**
 * Given some box information, which is a deeply-nested tree of values, create
 * an iterator that yields each bounding box in turn. This is used by various
 * functions to iterate over each bbox to aggregate up their values
 * in useful ways.
 *
 * @param mediaKeys
 * @param boxData
 */
export function* eachBoundingBox(
  mediaKeys: string[] | undefined,
  boxData: BoundingBoxData | undefined
) {
  if (!boxData || !mediaKeys) {
    return;
  }
  for (const mediaKey of mediaKeys) {
    const boxDataForMediaKey = boxData[mediaKey];
    if (boxDataForMediaKey != null) {
      for (const boxes of Object.values(boxData[mediaKey])) {
        for (const boundingBox of boxes) {
          yield boundingBox;
        }
      }
    }
  }
}
